export default "/images/vendor/flag-icon-css/flags/4x3/ec.svg?7d1693275c588cea2fe8b28595573bf5";